import React from 'react'
import './EditButtonWrapper.scss'
import PropTypes from 'prop-types'
import EditIcon from '@material-ui/icons/Edit'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {
    '&.MuiSvgIcon-root': {
      fontSize: '14px'
    }
  }
}))

export default function EditButtonWrapper(props) {
  const classes = useStyles()
  const { showWrapper = true, isTruncated } = props

  return (
    <>
      {showWrapper ? (
        <div
          className={`edit-container ${isTruncated && 'trimmed-content'}`}
          data-testid={
            props.dataTestId ? props.dataTestId : 'edit-button-container'
          }
          onClick={() => props.handleEditButtonClick()}
        >
          <div className="editButtonWrapper">{props.children}</div>
          <div className="edit-pen">
            <EditIcon className={classes.root} />
          </div>
        </div>
      ) : (
        props.children
      )}
    </>
  )
}

EditButtonWrapper.propTypes = {
  children: PropTypes.any,
  handleEditButtonClick: PropTypes.func,
  dataTestId: PropTypes.string,
  showWrapper: PropTypes.bool,
  isTruncated: PropTypes.bool
}
